export type QuoteType = 'Custom' | 'Fixed';

export const quoteTypes: Record<string, QuoteType> = {
  'custom': 'Custom',  // Note: 'Custom' for anonymous/no quote case
  'fixed': 'Fixed',
};
